import { defineStore } from "pinia";
import axios from "axios";

const defaultYAxis = { min: 0, max: 100, interval: 10 };

function formatMonthName(year, month) {
  const date = new Date(year, month - 1);
  const monthName = date.toLocaleString("pt-BR", { month: "long" });
  return monthName.charAt(0).toUpperCase() + monthName.slice(1);
}

async function fetchData(url, params = {}) {
  try {
    const response = await axios.get(url, { params });
    return response.data;
  } catch (err) {
    console.error(`Erro ao buscar ${url}:`, err);
    return null;
  }
}

export const useFinanceStore = defineStore("finance", {
  state: () => ({
    plan: null,
    used: 0,
    mostUsedDay: {},
    average: null,
    chartData: {
      assistents: { data: [], yAxis: defaultYAxis },
      contentGeneration: { data: [], yAxis: defaultYAxis },
    },
    monthlyFinances: [],
  }),

  actions: {
    updatePlan({ plan, used, most_used_day, average }) {
      this.plan = plan;
      this.used = used;
      this.mostUsedDay = most_used_day;
      this.average = average;
    },

    updateChart(type, chart = null) {
      if (!this.chartData[type]) return;

      if (chart) {
        this.chartData[type].data = chart.data || [];
        this.chartData[type].yAxis = chart.yAxis || defaultYAxis;
      } else {
        this.chartData[type].data = [];
        this.chartData[type].yAxis = defaultYAxis;
      }
    },

    updateMonthlyFinances(data) {
      if (!data?.success) {
        this.monthlyFinances = [];
        return;
      }

      this.monthlyFinances = data.data.map(f => ({
        ...f,
        month: formatMonthName(f.year, f.month),
      }));
    },
  
    async fetchPlanData() {
      const data = await fetchData("/api/assistents/resources/plan-data");
      if (data) this.updatePlan(data);
    },

    async fetchChartData(type, filterParams = {}) {
      const params = { integration_code: type, filter: filterParams.filter || "" };
      
      if (filterParams.filter === "period" && (!filterParams.endDate || !filterParams.startDate)){
        return
      }

      if (filterParams.filter === "period") {
        params.start_date = filterParams.startDate;
        params.end_date = filterParams.endDate;
      }

      const data = await fetchData("/api/assistents/resources/update-charts", params);

      if (!data) {
        this.updateChart(type);
        return;
      }

      if ((this.plan && data.plan) && (data.plan !== this.plan)) {
        await this.fetchPlanData();
        await this.fetchMonthlyFinances();
      }

      this.updateChart(type, data);
    },

    async fetchMonthlyFinances() {
      const data = await fetchData("/api/assistents/resources/monthly-finances");
      this.updateMonthlyFinances(data);
    },
  },
});
